<ckeditor *ngIf="isOnBrowser" [editor]="editor" [(ngModel)]="value" [config]="config" disabled></ckeditor>
